import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Link } from 'react-router-dom';
export function MobilePaymentsPage() {
  const {
    t,
    setLocale,
    direction,
    locale
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useScrollReveal();
  const {
    ref: desc2Ref,
    isVisible: desc2Visible
  } = useScrollReveal();
  const {
    ref: moreServicesRef,
    isVisible: moreServicesVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-845">
      <Header variant="transparent-dark" data-id="element-846" />

      <main data-id="element-847">
        {/* Wrapper for hero SVG spanning hero + next sections */}
        <div className="relative" data-id="element-848">
          {/* Decorative SVG - spans hero and next 2 sections */}
          <img src="https://cdn.magicpatterns.com/uploads/nkA8NY64niUffzUbiE5oLU/about-hero.svg" alt="" role="presentation" aria-hidden="true" className="absolute right-0 pointer-events-none z-[1]" style={{
          top: '50vh',
          height: '60%'
        }} data-id="element-849" />

          {/* 1. Hero Banner */}
          <section className="relative min-h-screen overflow-hidden" ref={heroRef} aria-label="Mobile Payments Hero" data-id="element-850">
            {/* Background Image */}
            <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
            backgroundImage: "url('https://cdn.magicpatterns.com/uploads/5yMj6pfff5bvG4qVzy8djm/merchant-aquiring.jpg')"
          }} data-id="element-851" />

            <div className="relative z-10 w-full min-h-screen flex items-center" data-id="element-852">
              <div className="container mx-auto px-6 md:px-12" data-id="element-853">
                <div className="max-w-3xl" data-id="element-854">
                  <h1 className={`text-[#061D76] font-semibold leading-[1.05] mb-10 uppercase text-[32px] md:text-[44px] lg:text-[55px] whitespace-pre-line reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-855">
                    {t('mobilePaymentsPage.hero.title')}
                  </h1>
                  <p className={`text-base md:text-lg text-[#061D76] mb-10 max-w-xl leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-856">
                    {t('mobilePaymentsPage.hero.subtitle')}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 2. Description Section - Dark gradient with text only */}
          <section className="section-inner gradient-dark-horizontal text-white relative overflow-hidden z-[2]" ref={descRef} aria-label="Mobile Payments Overview" data-id="element-857">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-858">
              <div className="max-w-5xl" data-id="element-859">
                <p className={`text-lg md:text-xl leading-relaxed reveal-hidden ${descVisible ? 'animate-fade-up' : ''}`} data-id="element-860">
                  {t('mobilePaymentsPage.description.paragraph1')}
                </p>
              </div>
            </div>
          </section>

          {/* 3. Light Section */}
          <section className="section-inner gradient-light relative overflow-hidden" ref={desc2Ref} aria-label="Mobile Payments Benefits" data-id="element-861">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-862">
              <div className="max-w-5xl" data-id="element-863">
                <p className={`text-lg md:text-xl text-[#061d76] leading-relaxed reveal-hidden ${desc2Visible ? 'animate-fade-up' : ''}`} data-id="element-864">
                  {t('mobilePaymentsPage.description.paragraph2')}
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* 4. More Services Section */}
        <section className="py-32 md:py-44 text-white relative overflow-hidden gradient-dark" dir={direction} ref={moreServicesRef} aria-label="More Services" data-id="element-865">
          {/* Background Curves */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1d8bba]/30 via-transparent to-transparent" aria-hidden="true" data-id="element-866"></div>

          {/* Top-right SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/2mANLj8GZ2QSoaHCJvcbje/more-service-top.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 right-0 w-[300px] md:w-[300px] h-auto pointer-events-none opacity-10" data-id="element-867" />

          {/* Bottom-left SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/6b9oFepPZ3EmycFXG1ZrBP/4.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 left-0 w-[1000px] h-auto pointer-events-none" data-id="element-868" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-869">
            <h2 className={`text-white font-bold mb-12 reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
            fontSize: '1.6rem'
          }} data-id="element-870">
              {t('mobilePaymentsPage.moreServices')}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-0" data-id="element-871">
              {[{
              title: t('services.cardIssuing.title'),
              description: t('services.cardIssuing.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/p9wNgXqTf5s865qgqSB29i/card.svg',
              href: locale === 'ar' ? '/ar/services/card-issuing' : '/services/card-issuing'
            }, {
              title: t('services.atmAcquiring.title'),
              description: t('services.atmAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jegNccbhUz8TByzbmLGE3q/atm.svg',
              href: locale === 'ar' ? '/ar/services/atm-acquiring' : '/services/atm-acquiring'
            }, {
              title: t('services.merchantAcquiring.title'),
              description: t('services.merchantAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/aLZSCF4LuiiMZtZnqW9PRT/merchant.svg',
              href: locale === 'ar' ? '/ar/services/merchant-acquiring' : '/services/merchant-acquiring'
            }].map((service, index) => <Link key={index} to={service.href} className={`group py-10 px-6 md:px-8 border border-white/10 hover:bg-[#25B8D6] transition-colors duration-300 cursor-pointer flex flex-col items-center justify-center text-center aspect-square reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${(index + 1) * 100}ms`
            }} data-id="element-872">
                  <img src={service.icon} alt={service.title} className="w-10 h-10 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-873" />
                  <h3 className="text-lg md:text-xl font-bold mb-3" data-id="element-874">
                    {service.title}
                  </h3>
                  <p className="text-white leading-relaxed text-sm" data-id="element-875">
                    {service.description}
                  </p>
                </Link>)}
            </div>
          </div>
        </section>

        {/* 5. Join Our Bold Thinkers CTA */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-876">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')"
        }} data-id="element-877"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-878">
            <div data-id="element-879">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-880">
                {t('aboutPage.cta.heading')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-881">
                {t('aboutPage.cta.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-882">
                {t('aboutPage.cta.button')}
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-883" />
    </div>;
}